/*
 * Edge Landing Agencies JavaScript
 * Migrated from no-vue/src/landing-agencies.js to Vite + Tailwind 4 setup
 */

import './landing-agencies.css';

// Import shared utilities
import '../shared/topbar.js';
import '../shared/coupon.js';
import '../shared/mobile-menu.js';
import '../shared/mega-menu.js';

// Import landing page-specific modules
import '../shared/landing/hero.js';
import '../shared/landing/animations.js';
import '../shared/landing/components.js';
import '../shared/landing/pricing-graph.js';

// Landing Agencies specific functionality
// Most functionality is handled by imported modules:
// - hero.js: Smooth scroll for CTA buttons
// - animations.js: Fade-in on scroll with [data-fade-in]
// - components.js: Accordions, tabs, tooltips
// - pricing-graph.js: Interactive pricing graph

class LandingAgencies {
  constructor() {
    this.init();
  }

  init() {
    // Page-specific initialization can go here
    // Most landing page features are auto-initialized by the imported modules
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new LandingAgencies();
  console.log('Landing: Agencies page loaded (Edge/Vite bundle)');
});
